// extracted by mini-css-extract-plugin
export default {"container":"NavBar2_container__0vneU","button":"NavBar2_button__QySIy","menu":"NavBar2_menu__MBAVY"};